export default __webpack_public_path__ + "static/media/ripe-ncc.76cd8859.png";